import { ObjectsFactory, Model } from './core'

export interface IBank {
  id: number
  name: string
  bank_account_name: string
  bank_account_number: string
  code: string
  shortName: string
  created_at: Date
  updated_at: Date
}

const modelConfig = {
  path: '/banks'
}

export class Bank extends Model {
  static queryKeys = {
    paginate: 'BANKS_PAGINATE_QUERY',
    findOne: 'BANKS_FIND_ONE_QUERY'
  }

  static objects = ObjectsFactory.factory<IBank>(modelConfig, this.queryKeys)

  static getBanksSelectOptions(banks: IBank[] | undefined) {
    if (!banks) return []

    return banks.map(item => ({
      value: item.id,
      label: item.name,
      shortName: item.shortName
    }))
  }
}

Bank.setup(modelConfig)
